import { render } from "./FullProjectInfo.vue?vue&type=template&id=d0a184ca&scoped=true"
import script from "./FullProjectInfo.vue?vue&type=script&lang=js"
export * from "./FullProjectInfo.vue?vue&type=script&lang=js"

import "./FullProjectInfo.vue?vue&type=style&index=0&id=d0a184ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0a184ca"]])

export default __exports__